module.exports = __webpack_public_path__ + "static/media/logo.29eb5cb4.png";